// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"59bb06f8","941":"c8ce90c7"}[chunkId] + ".chunk.js");